import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { ScrollText } from 'lucide-react';

const fmt = (iso) => new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
const ACTION_LABEL = {
  post_hide: 'Hid post', post_approve: 'Approved post', post_mark_gone: 'Marked post gone',
  post_remove: 'Removed post', post_extend: 'Extended post', post_shorten: 'Shortened post',
  ban_user: 'Banned user', suspend_user: 'Suspended user', unban_user: 'Reinstated user',
  update_settings: 'Updated settings', change_role: 'Changed role', report_staff: 'Reported staff to owner',
};

export default function AuditPanel() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get('/admin/audit-logs').then(r => setLogs(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="audit-panel">
      <h2 className="font-display font-bold text-2xl text-brand-ink mb-1">Audit log</h2>
      <p className="text-brand-slate text-sm mb-5">Every moderation action, attributed to an admin.</p>
      <div className="glass-panel rounded-3xl overflow-hidden">
        {logs.length === 0 ? (
          <div className="p-8 text-center text-brand-slate text-sm" data-testid="audit-empty">No actions logged yet.</div>
        ) : logs.map(l => (
          <div key={l.id} className="flex items-start gap-3 px-4 py-3 border-b border-black/5 last:border-0">
            <div className="w-8 h-8 rounded-full bg-brand/10 flex items-center justify-center shrink-0"><ScrollText className="w-4 h-4 text-brand" /></div>
            <div className="min-w-0 flex-1">
              <div className="text-sm text-brand-ink">
                <span className="font-semibold">@{l.admin_name}</span> {ACTION_LABEL[l.action] || l.action}
                <span className="text-brand-slate"> · {l.target_type} {l.target_id?.slice(0, 8)}</span>
              </div>
              {l.detail && <div className="text-xs text-brand-slate truncate">{l.detail}</div>}
            </div>
            <div className="text-xs text-brand-dim whitespace-nowrap">{fmt(l.created_at)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
